<template>
  <div class="row">
    <div class="row-content-wrapper is-clearfix">
      <div class="row-description">
        <b-switch
          v-model="mutateService.enable"
          @input="onChanged"
        >
          Скрыть блок услуги с  главной страницы сайта
        </b-switch>
        <b-field label="Title">
          <b-input
            v-model="mutateService.title"
            @input="onChanged"
          />
        </b-field>
        <b-field label="URL">
          <b-input
            v-model="mutateService.url"
            @input="onChanged"
          />
        </b-field>
        <b-field label="Description">
          <b-input
            v-model="mutateService.description"
            @input="onChanged"
          />
        </b-field>
        <b-field
          v-for="(item, index) of mutateService.items"
          :key="item"
          :label="' преимущество №' + (index + 1)"
        >
          <b-input
            :value="item"
            @input="mutateService.items[index] = $event"
            @blur="onChanged"
          />
        </b-field>
      </div>
      <div class="photo">
        <img src="/static/img/icons/home.svg" v-if="!mutateService.photo"/>
        <img :src='"/upload/photos/" + mutateService.photo' v-else/>
        <span @click="handleLoadServicePhoto">Изменить фото</span>
        <input
          type="file"
          id='photo'
          @change='loadPhoto'
          hidden
          ref="loadPhotoButton"
        />
      </div>
    </div>
    <div class="centered">
      <span
        class="button-wrapper centered"
        @click="onRemove"
      >
        <a class="button is-danger">-</a>
        Удалить
      </span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import { VueEditor as Editor } from 'vue2-editor'

export default {
  name: 'ServiceDragableItem',
  components: {
    Editor
  },
  data () {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{'align': ''}, {'align': 'center'}, {'align': 'right'}, {'align': 'justify'}],
        ['link']
      ],
      mutateService: {
        enable: true,
        url: '',
        description: '',
        title: '',
        photo: ''
      }
    }
  },
  props: {
    service: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.mutateService = deepcopy(this.service)
  },
  computed: {
    // ...mapState([])
  },
  methods: {
    ...mapActions([
      'loadServiceMainPagePhoto',
      'updateService',
      'photoUploadCommonServices'
    ]),

    handleLoadServicePhoto () {
      this.$refs.loadPhotoButton.click()
    },
    loadPhoto (e) {
      const reader = new FileReader()
      reader.readAsDataURL(e.target.files[0])
      const formData = new FormData()
      const file = e.target.files[0]
      formData.set('photo', file)
      reader.onload = async (e) => {
        const service = await this.photoUploadCommonServices({
          formData,
          id: this.mutateService.id
        })

        this.mutateService = service
      }
    },
    onChanged (...args) {
      this.$emit('input', deepcopy(this.mutateService))
    },
    onRemove () {
      this.$emit('remove', deepcopy(this.mutateService))
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// ServiceItem.vue?70f6e2c6